import { Instance } from 'mobx-state-tree'
import { MyPermissionsModelBase } from './MyPermissionsModel.base'

/* The TypeScript type of an instance of MyPermissionsModel */
export interface MyPermissionsModelType extends Instance<typeof MyPermissionsModel.Type> {}

/* A graphql query fragment builders for MyPermissionsModel */
export {
  selectFromMyPermissions,
  myPermissionsModelPrimitives,
  MyPermissionsModelSelector
} from './MyPermissionsModel.base'

/**
 * MyPermissionsModel
 */
export const MyPermissionsModel = MyPermissionsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
